import {
  Button,
  Form,
  Input,
  Modal,
  Flex,
  Select,
  CheckboxProps,
  Checkbox,
  Card,
} from "antd";
import { useForm } from "antd/es/form/Form";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import {
  AddEmailLicense,
  // GetDomainList,
  GetEmailLicensingGetEmail,
  GetEmailLicensingGetEmployees,
  GetGroupsList,
  GetSpecialEmailList,
  UpdateEmailLicense,
  axiosErrorMessages,
} from "../../../../API/api";
import axios, { AxiosError } from "axios";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

interface AddEditEmailListType {
  isAdd: boolean;
  editData: any;
  handleClose: (data: boolean) => void;
}

interface DomainObj {
  value: number;
  label: string;
}
const AddEditEmailList: React.FC<AddEditEmailListType> = ({
  isAdd,
  editData,
  handleClose,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [employeeList, setEmployeeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [domainList, setDomainList] = useState<DomainObj[]>([]);
  const [groupList, setGroupList] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [domainId, setDomainId] = useState<number>(0);
  const [specialEmailList, setSpecialEmailList] = useState<DomainObj[]>([]);
  const handleCloseAddEditPopup = () => {
    setIsOpen(false);
    handleClose(true);
  };

  useEffect(() => {
    fetchEmployeesList();
    // getDomainList();
    fetchGroupsList();
    fetchSpecialEmailList();
  }, []);

  const fetchEmployeesList = async () => {
    try {
      setIsLoading(true);
      const response = await GetEmailLicensingGetEmployees();
      const newData = response.data.map((employees: any, index: number) => ({
        value: employees.employeeId,
        label: employees.employeeName,
      }));
      setEmployeeList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  // const getDomainList = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await GetDomainList();
  //     const newData = response.data.map((domain: any, index: number) => ({
  //       value: domain.domainId,
  //       label: domain.domain,
  //     }));
  //     setDomainList(newData);
  //     setIsLoading(false);
  //   } catch (error: any) {
  //     let errorMsg;
  //     if (axios.isAxiosError(error)) {
  //       const axiosError = error as AxiosError;
  //       errorMsg = axiosErrorMessages(axiosError);
  //     } else {
  //       errorMsg = error.message;
  //     }
  //     enqueueSnackbar(errorMsg, {
  //       variant: "error",
  //       anchorOrigin: {
  //         vertical: "top",
  //         horizontal: "right",
  //       },
  //     });

  //     setIsLoading(false);
  //   }
  // };

  const fetchGroupsList = async () => {
    try {
      setIsLoading(true);
      const response = await GetGroupsList();
      const newData = response.data.map((groups: any, index: number) => ({
        value: groups.groupId,
        label: groups.groupName,
      }));
      console.log("groups", newData);
      setGroupList(newData);
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };
  const fetchSpecialEmailList = async () => {
    try {
      setIsLoading(true);
      const response = await GetSpecialEmailList();
      if (response.data) {
        const newData = response?.data?.map((email: any, index: number) => ({
          value: email.specialEmailId,
          label: email.email,
        }));
        setSpecialEmailList(newData);
      }

      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };
  const addNewEmailLicense = async (data: any) => {
    const saveData = {
      employeeId: data.employeeId,
      groupId: data.groupId,
      routing: data.routing ? data.routing : false,
      specialEmailIds: data.specialEmailId ? data.specialEmailId : [],
    };
    AddEmailLicense(saveData)
      .then((response: any) => {
        enqueueSnackbar("Added Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        handleClose(true);
      })
      .catch((error: any) => {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      });
  };

  const updateEmailLicenses = async (data: any) => {
    const saveData = {
      groupId: data.groupId,
      routing: data.routing ? data.routing : false,
      specialEmailId: data.specialEmailId ? data.specialEmailId : "",
      emailLicensingId: editData.emailLicensingId,
    };
    UpdateEmailLicense(saveData)
      .then((response: any) => {
        enqueueSnackbar("Updated Successfully", {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        handleClose(true);
      })
      .catch((error: any) => {
        if (error.response.data.errors.Group[0])
          enqueueSnackbar(error.response.data.errors.Group[0], {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        else {
          let errorMsg;
          if (axios.isAxiosError(error)) {
            const axiosError = error as AxiosError;
            errorMsg = axiosErrorMessages(axiosError);
          } else {
            errorMsg = error.message;
          }
          enqueueSnackbar(errorMsg, {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
      });
  };

  const onFinish = async (values: any) => {
    if (isAdd) {
      addNewEmailLicense(values);
    } else {
      updateEmailLicenses(values);
    }
  };

  const onCheckboxChange: CheckboxProps["onChange"] = (e) => {
    const check = e.target.checked;
    setIsChecked(check);
    if (!check) {
      // Clear all special email fields when checkbox is unchecked
      form.setFieldsValue({ specialEmail: [] });
    }
  };

  const handleEmployeeId = async (value: string) => {
    const id = value;
    try {
      setIsLoading(true);
      const response = await GetEmailLicensingGetEmail(id);
      const newData = response.data;
      setEmail(email);
      form.setFieldsValue({ emailId: newData.email });
      setIsLoading(false);
    } catch (error: any) {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });

      setIsLoading(false);
    }
  };

  const handleResetForm = () => {
    setIsChecked(editData.specialEmailId ? true : false);
    form.setFieldsValue({
      employeeId: editData.employeeName,
      emailId: editData.emailId,
      groupId: editData.group.map((group: { groupId: any }) => group.groupId),
      routing: editData.routing,
    });
  };

  const [form] = Form.useForm();
  type FieldType = {
    employeeId?: string;
    emailId?: string;
    specialEmailId?: [];
    routing?: boolean;
    groupId?: [];
  };
  useEffect(() => {
    if (!isAdd) {
      form.setFieldsValue({
        employeeId: editData.employeeName,
        emailId: editData.emailId,
        specialEmailId: editData.specialEmails.map(
          (email: any) => email.specialEmailId
        ),

        groupId: editData.group.map((group: { groupId: any }) => group.groupId),
        routing: editData.routing,
        // emailCheck: editData.specialEmailId,
      });
      if (editData.specialEmailId) setIsChecked(true);
    }
  }, []);

  // useEffect(() => {
  //   if (!isAdd) {
  //     if (domainList) {
  //       const domain = domainList.find(
  //         (item) => item.label === editData.domainName
  //       );
  //       form.setFieldsValue({ domainId: domain?.value });
  //     }
  //   }
  // }, [domainList]);

  const filterOption = (
    input: string,
    option?: { label: string; value: number }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <>
      <div>
        <Modal
          footer={null}
          title="Add/Edit Details"
          open={isOpen}
          onCancel={handleCloseAddEditPopup}
          maskClosable={false}
        >
          <Form
            name="basic"
            form={form}
            autoComplete="off"
            layout="vertical"
            onFinish={onFinish}
            onReset={handleResetForm}
          >
            <Form.Item<FieldType>
              rules={[{ required: true, message: "Enter Employee" }]}
              label="Employee Name"
              name="employeeId"
            >
              <Select
                maxTagCount="responsive"
                disabled={!isAdd}
                style={{ width: 300 }}
                placeholder="Select Employee"
                options={employeeList}
                showSearch
                onChange={handleEmployeeId}
                filterOption={filterOption}
              />
            </Form.Item>
            <Form.Item<FieldType>
              label="Email Id"
              name="emailId"
              style={{ width: 300 }}
            >
              <Input readOnly />
            </Form.Item>
            {/* <Form.Item<FieldType>
              label="Domain Name"
              name="domainId"
              rules={[{ required: true, message: "Select Domain Name" }]}
            >
              <Select
                style={{ width: 300 }}
                placeholder="Select Domain"
                options={domainList}
                showSearch
                filterOption={filterOption}
              />
            </Form.Item> */}

            <Form.Item<FieldType>
              label="Group Name(Group Email Id)"
              name="groupId"
              rules={[{ required: true, message: "Select Group" }]}
            >
              <Select
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: 300 }}
                placeholder="Select Group"
                options={groupList}
                showSearch
                filterOption={filterOption}
              />
            </Form.Item>
            {/* <Form.Item valuePropName="checked" name="emailCheck">
              <Checkbox onChange={onCheckboxChange}>Special Email Id</Checkbox>
            </Form.Item> */}
            <Form.Item<FieldType>
              label="Special Email ID"
              name="specialEmailId"
            >
              <Select
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: 300 }}
                placeholder="Select Special Email ID"
                options={specialEmailList}
                showSearch
                filterOption={filterOption}
              />
            </Form.Item>

            <Form.Item<FieldType> valuePropName="checked" name="routing">
              <Checkbox>Routing</Checkbox>
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button className="pm-btn" type="primary" htmlType="submit">
                Save
              </Button>
              {!isAdd && (
                <Button
                  style={{ marginLeft: 20 }}
                  className="pm-btn"
                  type="primary"
                  htmlType="reset"
                >
                  Reset
                </Button>
              )}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default AddEditEmailList;
